<template>
  <div>
    <slot />
  </div>
</template>

<script setup lang="ts">
  import { watch } from 'vue'
  import { debounce, throttle } from '@/lib/timing'
  import { useSavingIndicatorStore } from '@/store/savingIndicatorStore'

  const autoSavingIndicatorStore = useSavingIndicatorStore()

  const props = defineProps({
    values: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    debounceDelay: {
      type: Number,
      default: 1000
    },
    throttleInterval: {
      type: Number,
      default: 1000
    }
  })

  const emit = defineEmits(['save'])

  const debouncedSave = debounce((values: any) => {
    console.log('debouncedSave called', values)
    autoSavingIndicatorStore.indicateSaving()
    emit('save', values)
  }, props.debounceDelay)

  const throttledSave = throttle((values: any) => {
    console.log('throttledSave called', values)
    debouncedSave(values)
  }, props.throttleInterval)

  watch(
    () => props.values,
    async (newValues) => {
      console.log('AutoSavingForm watch triggered', newValues)
      if (props.meta.valid) {
        console.log('Form is valid, calling throttledSave')
        throttledSave(newValues)
      } else {
        console.log('Form is not valid, not saving', props.meta.errors)
      }
    },
    { deep: true }
  )
</script>
